export const assetTypes = [
  { id: 'real_estate', label: 'Real Estate' },
  { id: 'stocks', label: 'Stocks & Bonds' },
  { id: 'business', label: 'Business' },
  { id: 'vehicle', label: 'Vehicle' },
  { id: 'jewelry', label: 'Jewelry & Collectibles' },
  { id: 'digital', label: 'Digital Assets' }
];
